<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc1"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter1">1. A Different Type of Law and Order</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">2. Prohibition</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">3. Boom!</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">4. The Foshay Tower: A Monument to Flimflammery</span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">5. Crash</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">6. Kid Cann</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">7. Women and Crime</span></p>
<p class="toc"><span href="#/chapter8" title="Link target outside of Sample">8. The Murder of Investigative Journalist Walter Liggett</span></p>
<p class="toc"><span href="#/chapter9" title="Link target outside of Sample">9. Leon Gleckman, St. Paul’s Al Capone</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Redwood Falls Bank Heist</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. Captain Billy’s Breezy Point Lodge</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Revenuers Raid New Ulm, Minnesota</span></p>
<p class="toc1"><span href="#/conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?0e60a10a